import { Injectable } from '@angular/core';
import { FirestoreService } from './firestore/firestore.service';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';

import { CountryService } from '../services/country.service';
import { StateService } from '../services/state.service';
import { CFDI } from './customer-bill.service';
import { CompanyData } from './company.service';

export interface FiscalData {
  active: boolean;
  businessName: string;
  countryId: string;
  municipality: string;
  createdAt: any;
  customerId: string;
  email: string;
  email2: string;
  phone: string;
  externalNumber: string;
  internalNumber: string;
  neighborhood: string;
  rfc: string;
  stateId: string;
  street: string;
  supplierId: string;
  updatedAt: any;
  postCode: string;
	xlocality: string;
	xmunicipality: string;
  fiscalRegimen: keyof CompanyData['fiscalRegimenSelect'],
  creditLimitAmount?: number;
  creditLimitDays?: number;
  creditLimitAmountInside?: number;
  creditLimitDaysInside?: number;
  accountingCode?: string;

  cfdi: CFDI;

  notes: string;

}

export interface FiscalDataId extends FiscalData {
  id: string;
}

@Injectable()
export class FiscalDataService {

  fiscalDatas$: Observable<any[]>;

  collection: string;

  constructor(
    private afh: FirestoreService,
    private countryService: CountryService,
    private stateService: StateService
  ) {
    this.collection = Globals.FISCAL_DATA_COLLECTION;
  }

  getSupplierFiscalDatas(supplierId: string) {
    return this.afh.colWithIds$(this.collection, ref => ref.where('supplierId', '==', supplierId).where('active', '==', true) );
  }
  getCustomerFiscalDatas(customerId: string){
    return this.afh.colWithIds$(this.collection, ref => ref.where('customerId', '==', customerId).where('active', '==', true) );
  }
  getAllFiscalDatas(){
    return this.afh.colWithIds$(this.collection);
  }
  getFiscalDatas(customerSupplierId: string, customerOrSupplier: string) {
    this.fiscalDatas$ = this.afh.colWithIds$(this.collection, ref => {
      return ref.where(customerOrSupplier, '==', customerSupplierId).where('active', '==', true) ;
    }).map(documents => {
      return documents.map(document => {
        const data = {
          id: document.id,
          name: document.rfc,
          businessName: document.businessName
        }
        return data;
      })
    })
    return this.fiscalDatas$;
  }
  getFiscalData(fiscalDataId: string) {
    return this.afh.docWithIds$(`${this.collection}/${fiscalDataId}`);
  }

  displayFiscalData(fiscalDataId: string){
    return this.afh.docWithIds$(`${this.collection}/${fiscalDataId}`);
  }

  addFiscalData(fiscalData: any) {
    return this.afh.add(this.collection, fiscalData);
  }
  updateFiscalData(id: string, fiscalData: any) {
    this.afh.update(`${this.collection}/${id}`, fiscalData);
  }
  deleteFiscalData(id: string){
    this.afh.delete(`${this.collection}/${id}`);
  }

}

/* class FISCAL{
  accountingCode: string;
  active: boolean;
  businessName: string;
  countryId: string;
  createdAt: any;
  creditLimitAmount?: number;
  creditLimitDays?: number;
  creditLimitAmountInside?: number;
  creditLimitDaysInside?: number;
  customerId: string;
  email: string;
  email2: string;
  externalNumber: string;
  internalNumber: string;
  municipality: string;
  neighborhood: string;
  rfc: string;
  stateId: string;
  street: string;
  supplierId: string;
  updatedAt: any;

  notes: string;
  constructor(description, name, street, neighborhood, city, stateName, zipCode, creditDays, creditAmount, rfc){
    this.accountingCode = '';
    this.active = true;
    this.businessName = name;
    this.countryId = '1';
    this.createdAt = new Date();
    this.creditLimitAmount = creditAmount;
    this.creditLimitDays = creditDays;
    this.creditLimitAmountInside = 0;
    this.creditLimitDaysInside = 0;
    this.customerId = '';// JSON.parse(localStorage.customersJson)[description];
    this.email = '';
    this.email2 = '';
    this.externalNumber = '';
    this.internalNumber = '';
    this.municipality = city;
    this.neighborhood = neighborhood;
    this.rfc = rfc;
    this.stateId = states[stateName] || '999';
    this.street = street;
    this.supplierId = JSON.parse(localStorage.suppliersJson)[description];
    this.updatedAt = this.createdAt;

    this.notes = zipCode ? `CP: ${zipCode}` : '';
  }
}
var states = {
  'Jal.': '14',
  'Pue.' : '21',
  'B.C.': '2',
	'D. F.': '9',
	'Mex': '15',
	'N.L.': '19',
	'Gua': '11',
  'Qro.': '22',
  'Mich.': '16',
  'Mor.': '17',
  'Ver.': '30'
} */